export enum ProductApi {
  getProduct = '/product/:productId',
  searchProducts = '/product/search',
  getProductLastSoldDetails = '/order-items/history',
  realtimeInventory = '/inventory/realtime/:productId',
  getPromotions = '/promotion/search',
  getConfigurations = '/product/configuration',
  // DEV-637 — batch lookup of catalog-linked alternates, keyed by original SKU.
  // Max 200 skus per request; more answers 400.
  getAlternates = '/product/alternates'
}
